import { useH5Mock } from "../global/GlobalMock";
import { post } from "../utils/Backend";
import { mockGetWeworkServiceHomePopup, mockGetWeworkServiceLiveCode } from "./WeworkServiceMock";
import type { WeworkServiceHomePopupData, WeworkServiceLiveCodeData } from "./WeworkServiceType";

const mockWeworkService = false;

export const WeworkServiceApi = {
  getHomePopup: async (p: { spaceId: string }): Promise<WeworkServiceHomePopupData | null> => {
    if (useH5Mock && mockWeworkService) {
      return mockGetWeworkServiceHomePopup();
    }
    const res = await post<{ spaceId: string }, WeworkServiceHomePopupData | null>(
      "/lark/app/space/getWeworkServiceHomePopup",
      p,
      { silent: true }
    );
    if (typeof res === "string" || res == null) {
      return null;
    }
    const showWeworkQrcode = !!res.showWeworkQrcode;
    const card =
      showWeworkQrcode && res.card?.qrcodeUrl?.trim() ? res.card : null;
    return {
      title: res.title,
      content: res.content,
      popupVersion: res.popupVersion ?? 0,
      showWeworkQrcode,
      card,
    };
  },

  getLiveCode: async (p: { spaceId: string }): Promise<WeworkServiceLiveCodeData | null> => {
    if (useH5Mock && mockWeworkService) {
      return mockGetWeworkServiceLiveCode();
    }
    const res = await post<{ spaceId: string }, WeworkServiceLiveCodeData | null>(
      "/lark/app/space/getWeworkServiceLiveCode",
      p,
      { silent: true }
    );
    if (typeof res === "string" || res == null) {
      return null;
    }
    if (!res.card?.qrcodeUrl?.trim()) {
      return null;
    }
    return res;
  },

  getMyBound: async (p: { spaceId: string }): Promise<WeworkServiceLiveCodeData | null> => {
    if (useH5Mock && mockWeworkService) {
      return mockGetWeworkServiceLiveCode();
    }
    const res = await post<{ spaceId: string }, WeworkServiceLiveCodeData | null>(
      "/lark/app/space/getMyBoundSpaceWeworkService",
      p
    );
    if (typeof res === "string" || res == null) {
      return null;
    }
    if (!res.card?.qrcodeUrl?.trim()) {
      return null;
    }
    return res;
  },
};
